import { Component, Prop, Vue } from 'vue-property-decorator';
import { OrderingListViewModel, UpdateOrderingListCommand,DeleteOrderingListCommand} from "Api/CoreApi";
import store from "Store/index"
import { mixins } from 'vue-class-component';
import BaseComponent from 'Components/Base/ABaseComponent';
import OrderingListUserMixin from 'Mixins/OrderingListUserMixin';
import { updateDo } from 'typescript';
import { EditCustomerViewModel } from 'Api/DynamicwebApi';

const name = 'ordering-list-detail-edit-customer';


@Component({
    template: "#ordering-list-detail-edit-customer-template"
})
export default class OrderingListDetailEditCustomerComponent extends mixins(BaseComponent, OrderingListUserMixin) {

    @Prop()
    public detail: OrderingListViewModel;

    public collapsed: boolean = true;

    public loaded: boolean = false;

    private buttonWrapperHtmlElement: HTMLElement = null;

    async mounted(){

        this.buttonWrapperHtmlElement = <HTMLElement>this.$refs.buttons;
        if(!this.buttonWrapperHtmlElement) return;

        var replaceTo = document.getElementById('hierarchy'+this.detail.userIsolationKey).querySelector('[data-append-'+name+'-btns]');
        if(!replaceTo) return;

        replaceTo.appendChild(this.buttonWrapperHtmlElement);
    }


    toggleCollapse(){
        if(!this.loaded) this.loaded = true;
        this.collapsed = !this.collapsed;
    }

    //listen to form emits
    updateDetails(obj: any){
        console.debug('edit customer updated details: ', obj);
        var model = new EditCustomerViewModel();
        model.init(obj);
        var updateObj = this.detail.userHierarchy;
        updateObj.companyName = model.companyName;
        updateObj.customerAddress = model.address;
        updateObj.customerAddress2 = model.address2;
        updateObj.postalCode = model.zip;
        updateObj.postalCity = model.city;
        
    }
}

Vue.component(name, OrderingListDetailEditCustomerComponent);